// The membership is on sale. Its benefits are every past version of a game's
// packages, the device colours and the palette, a member's games on Pocket TV,
// and what src/core/perks.ts lists as to come. A game's current packages are
// free for every account.
//
// The two switches are here so a simulation can close the sale again
// (test/accounts.test.ts): with signups closed nothing is sold and existing
// subscriptions and grants keep what they have.
export const MEMBERSHIP_SIGNUPS_OPEN: boolean = true;
export const EXTRA_DEVICE_COLOURS_VISIBLE: boolean = true;

export const MEMBERSHIP_PAUSED = "New memberships are paused while we update the benefits.";
